// The compliance config uses `Infinity` for "unlimited" limits, which JSON cannot represent
// (JSON.stringify turns it into null). When the config is delivered from the API to the browser
// through the react-env / window.reactEnv channel (which JSON-stringifies), we sentinel-encode
// Infinity on the way out and decode it on the way in. Both ends are first-party and we control
// them, so the sentinel convention can't drift.

// Distinctive, namespaced sentinels so they can't collide with a real string field in the
// config (e.g. a free-text `message`).
var POSITIVE_INFINITY_SENTINEL = '__ECOMM_COMPLIANCE_POSITIVE_INFINITY__';
var NEGATIVE_INFINITY_SENTINEL = '__ECOMM_COMPLIANCE_NEGATIVE_INFINITY__';
var deepTransform = function deepTransform(value, transformLeaf) {
  // `ancestors` tracks the current recursion path so a circular reference throws a clear error
  // instead of overflowing the stack. It's a path set (removed on unwind), so shared but acyclic
  // references (DAGs) don't false-positive.
  var walk = function walk(node, ancestors) {
    if (node && typeof node === 'object') {
      if (ancestors.has(node)) {
        throw new Error('compliance-serialization: circular reference detected');
      }
      ancestors.add(node);
      var result = Array.isArray(node) ? node.map(function (item) {
        return walk(item, ancestors);
      }) : Object.keys(node).reduce(function (acc, key) {
        acc[key] = walk(node[key], ancestors);
        return acc;
      }, {});
      ancestors["delete"](node);
      return result;
    }
    return transformLeaf(node);
  };
  return walk(value, new Set());
};
export var encodeComplianceConfig = function encodeComplianceConfig(config) {
  return deepTransform(config, function (leaf) {
    if (leaf === Infinity) {
      return POSITIVE_INFINITY_SENTINEL;
    }
    if (leaf === -Infinity) {
      return NEGATIVE_INFINITY_SENTINEL;
    }
    return leaf;
  });
};
export var decodeComplianceConfig = function decodeComplianceConfig(config) {
  return deepTransform(config, function (leaf) {
    if (leaf === POSITIVE_INFINITY_SENTINEL) {
      return Infinity;
    }
    if (leaf === NEGATIVE_INFINITY_SENTINEL) {
      return -Infinity;
    }
    return leaf;
  });
};